import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IAssignments, IAssignmentsState } from "redux/types/assignments.types";
import { UserType } from "service";
import { getListAssignments, getManagersList } from "service/api";

const ns = "assignments";

const initialState: IAssignmentsState = {
  assignments: {
    error: "",
    loading: false,
  },
  managers: {
    error: "",
    loading: false,
  },
};

export const assignmentsLoadAssignments = createAsyncThunk(
  `${ns}/loadAssignments`,
  async (
    {
      offset,
      limit,
      userType,
      application_no,
      company_name,
      assignment_type,
      assignee_id,
      application_year,
    }: {
      offset: number;
      limit: number;
      userType: UserType;
      application_no?: number;
      company_name?: string;
      assignment_type?: string;
      assignee_id?: string,
      application_year?: string,
    },
    { dispatch }
  ) => {
    try {
      dispatch(assignmentsActions.setAssignmentsLoading(true));

      let rdata: any = {};
      if (userType === UserType.Admin) {
        rdata = await getListAssignments({
          userType: userType,
          offset: offset,
          limit: limit,
          application_no: application_no,
          company_name: company_name,
          assignment_type: assignment_type,
          assignee_id: assignee_id,
          application_year: application_year,
        });
      } else if (userType === UserType.Manager) {
        rdata = await getListAssignments({
          userType: userType,
          offset: offset,
          limit: limit,
          application_no: application_no,
          company_name: company_name,
          assignment_type: assignment_type,
          application_year: application_year,
        });
      } else {
        dispatch(
          assignmentsActions.setAssignmentsError(
            `User type ${userType} can't fetch assignments`
          )
        );
        dispatch(assignmentsActions.setAssignmentsLoading(false));
        return;
      }

      const assignments_list = rdata.assignments_list;
      dispatch(
        assignmentsActions.setAssignmentsValue({
          total: assignments_list.total,
          list: assignments_list.objects,
          info: rdata.assignments_info,
        })
      );
    } catch (error: any) {
      console.error(error);
      assignmentsActions.setAssignmentsError(error.message);
    } finally {
      dispatch(assignmentsActions.setAssignmentsLoading(false));
    }
  }
);

export const assignmentsLoadManagers = createAsyncThunk(
  `${ns}/loadManagers`,
  async (_, { dispatch }) => {
    try {
      dispatch(assignmentsActions.setManagersLoading(true));
      const rdata = await getManagersList();
      dispatch(assignmentsActions.setManagersValue(rdata.managers));
    } catch (error: any) {
      console.error(error);
      assignmentsActions.setManagersError(error.message);
    } finally {
      dispatch(assignmentsActions.setManagersLoading(false));
    }
  }
);

const assignments = createSlice({
  name: ns,
  initialState: initialState,
  reducers: {
    setAssignmentsValue: (state, action: PayloadAction<IAssignments>) => {
      state.assignments.value = action.payload;
    },
    setAssignmentsLoading: (state, action: PayloadAction<boolean>) => {
      state.assignments.loading = action.payload;
    },
    setAssignmentsError: (state, action: PayloadAction<string>) => {
      state.assignments.error = action.payload;
    },
    setManagersValue: (state, action: PayloadAction<any[]>) => {
      state.managers.value = action.payload;
    },
    setManagersLoading: (state, action: PayloadAction<boolean>) => {
      state.managers.loading = action.payload;
    },
    setManagersError: (state, action: PayloadAction<string>) => {
      state.managers.error = action.payload;
    },
  },
});

export const assignmentsActions = assignments.actions;
export const assignmentsReducer = assignments.reducer;
